module.exports = __webpack_public_path__ + "img/speak7.83dfed73.png";